import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import {
  NotificationChannelPreference,
  NotificationChannelType,
} from 'types/notification_channel';

import { useAPI } from 'hooks/api/useAPI';

export type UpsertNotificationChannelPreferenceParams = {
  applicationId: string;
  channel_type: NotificationChannelType;
  enabled: boolean;
};

export function useUpsertNotificationChannelPreference({
  onSettled,
  ...options
}: UseMutationOptions<
  NotificationChannelPreference,
  APIError,
  UpsertNotificationChannelPreferenceParams
> = {}) {
  const queryClient = useQueryClient();
  const { client } = useAPI();

  return useMutation(
    async ({ applicationId, channel_type, enabled }) => {
      const { data } = await client.put<NotificationChannelPreference>(
        `/apps/${applicationId}/notification_channel_preferences`,
        { channel_type, enabled }
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['notification-channel-preferences']);
      },
    }
  );
}
